<ng-container [formGroup]="formGroup">
  <mat-form-field class="settings-form__email-input">
    <mat-label>{{ "NOTIFICATION_SERVICE.EDIT.EMAIL_ADDRESS" | translate }}</mat-label>
    <input matInput formControlName="email" />
    <mat-icon matSuffix fontIcon="ec_edit"></mat-icon>
  </mat-form-field>
  <mat-divider big></mat-divider>
  <div class="settings-form__email-checkboxes">
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox formControlName="startEnd" [disableRipple]="true" [(indeterminate)]="indeterminate.startEnd">{{
        "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.UPDATE" | translate
      }}</mat-checkbox>
    </div>
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox
        formControlName="intermediate"
        [(indeterminate)]="indeterminate.intermediate"
        [disableRipple]="true"
        >{{ "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.INTERMEDIATE" | translate }}</mat-checkbox
      >
    </div>
    <div class="settings-form__checkbox-wrapper">
      <mat-checkbox
        formControlName="customerSatisfactionSurvey"
        [disableRipple]="true"
        [(indeterminate)]="indeterminate.customerSatisfactionSurvey"
      >
        {{ "NOTIFICATION_SERVICE.EDIT.STREET_LIGHTING.SATISFACTION_SURVEY" | translate }}
      </mat-checkbox>
    </div>
  </div>
</ng-container>
